/**
 * T-12: Response transformer — normalizes snake_case API response keys to camelCase.
 * Applied in HttpBennieClient fetch/fetchFormData methods so all downstream code
 * uses consistent camelCase field names. Eliminates ad-hoc dual-path mappings.
 */

/** Convert a single snake_case string to camelCase. Non-snake_case strings pass through unchanged. */
export function snakeToCamel(str: string): string {
  if (!str.includes('_')) return str;
  return str.replace(/_([a-z0-9])/g, (_, char) => char.toUpperCase());
}

/**
 * Deep-transform all object keys from snake_case to camelCase.
 * - Arrays: recurse into each element
 * - Objects: transform keys + recurse into values
 * - Primitives: return as-is
 */
export function transformKeys<T>(data: unknown): T {
  if (data === null || data === undefined) return data as T;
  if (Array.isArray(data)) return data.map((item) => transformKeys(item)) as T;
  if (typeof data === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
      result[snakeToCamel(key)] = transformKeys(value);
    }
    return result as T;
  }
  return data as T;
}
